export default __webpack_public_path__ + "static/media/dragon_10.1101cd27.mp3";